<template>
    <div class="recharge">
        <HeaderReturn title="密钥管理"></HeaderReturn>
        <!-- 地址 -->
        <div class="recharge_dz">
            <div class="details_finance d-flex">
                <div>
                    <!-- <img src="../../assets/img/page/j3.png" alt=""> -->
                </div>
                <div>
                    <span style="color: #f89b19;">备份助记词</span>
                    <span>(请妥善保管您的助记词)</span>
                </div>
            </div>
            <el-input disabled v-model="rechareForm.addr" placeholder="">
                <i slot="suffix" class="el-input__icon el-icon-document-copy" v-clipboard:copy="rechareForm.addr"
                    v-clipboard:success="onCopy"></i>
            </el-input>
        </div>
        <div class="recharge_btn">
            <el-button v-clipboard:copy="rechareForm.addr"
                    v-clipboard:success="onCopy">一键复制</el-button>
        </div>







    </div>
</template>
<script>
import Vue from 'vue';
import { NoticeBar, Icon } from 'vant';
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
export default {
    components: {
        vueQr,
    },
    data() {
        return {
            baseApi: "",
            UrlYqhy: "",
            udunList: [
                {
                    primaryNet: "BTC",
                    mainCoinType: "BTC"
                },
                {
                    primaryNet: "USDT",
                    mainCoinType: "USDT"
                }, {
                    primaryNet: "ETH",
                    mainCoinType: "ETH"
                }, {
                    primaryNet: "FIL",
                    mainCoinType: "FIL"
                }
            ],
            rechareForm: {
                mainCoinType: "BTC",
                addr: "1",
                value: '',
                bz: ""
            }



        }
    },
    created() {
        this.baseApi = process.env.VUE_APP_IMG;
        this.UrlYqhy = window.location.origin + '/#/reg?promotion=' + '1111';
        this.rechareForm.addr=JSON.parse(sessionStorage.getItem('ms_user')).user.token;
    },
    methods: {
        changeRechareNet(mainCoinType) {
            this.rechareForm.mainCoinType = mainCoinType;
        },
        onCopy() {
            this.$toast(this.$t('myself.a23'))
        },
        goLink(path) {
            if (path) {
                this.$router.push({
                    path,
                });
            } else {
                // 暂未开放
                this.$toast(this.$t('orePond.a42'));
            }
        }
    }
}
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

.recharge {
    margin: 50px 10px;

    ::v-deep .van-nav-bar__title {
        color: #f89b19;
        font-size: 20px;
        font-weight: 600;
    }

    .recharge_selet {
        margin-top: 20px;
        width: 100%;

        .el-select {
            width: 100%;
            background: transparent;
            /* 黄/主题 */

            border: 0.5px solid #f89b19;
                border: 0;
                border-radius: 4px;

        }

        ::v-deep .el-input__inner {
            border: 0 !important;
            background: transparent;
            /* 黄/主题 */

            border: 0.5px solid #f89b19;
        }

    }

    .recharge_qr {
        margin: 45px 0 35px 0;
        text-align: center;
    }

    .recharge_dz {
        ::v-deep .el-input__inner {

            background: transparent;
            /* 黄/主题 */

            border: 0.5px solid #f89b19;

        }

        .details_finance {
            margin: 60px 0px 20px 0px;

            div {
                img {
                    width: 100%;
                    height: 100%;
                }

                &:nth-child(2) {
                    font-family: 'PingFang SC';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 22px;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    margin-left: 10px;

                    /* 黄/主题 */


                }
            }
        }

    }

    .recharge_val {
        margin: 20px 0;

        p {
            margin: 0 0 20px 0;
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;

            /* 白/FE */

            color: #FEFEFE;

        }

        ::v-deep .el-input__inner {


            color: #fff;
            background: transparent;
            /* 黄/主题 */

            border: 0.5px solid #f89b19;
            border-radius: 4px;
        }
    }

    .recharge_btn {
        padding-bottom: 40px;
        position: relative;
        top: 450px;
        width: 100%;


        .el-button {
            width: 100%;
            background: #f89b19;
            border: 0;
            color: #FEFEFE;
        }
    }








}
</style>